import { Pipe, PipeTransform, inject } from '@angular/core';
import { HisBaseGlobalsService } from '../service/base/his-base-globals.service';

/**
 * looks up uitext for entities with support for the Data Dictionary.
 */
@Pipe( {
    name: 'hisUidd',
    standalone: false
} )
export class HisUiddPipe implements PipeTransform {
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);


    transform( key: string ): string {
        // TODO: lookup key in DataDictionary to check if the ui key was redefined
        return ( key ) ? this.hisBaseGlobalsService.getUi( key ) : key;
    }
}
